import Button from "@mui/material/Button";
import { SaveButton, Toolbar, useRefresh } from "react-admin";
import { useFormContext } from "react-hook-form";

import { useGoToPreviousPage, useLayoutMode } from "common";

interface FormToolbarProps {
  saveButtonLabel?: string;
  onSuccess?: () => void;
}

export const FormToolbar = ({ saveButtonLabel, onSuccess }: FormToolbarProps) => {
  const layoutMode = useLayoutMode();
  const refresh = useRefresh();
  const goToPreviousPage = useGoToPreviousPage();

  const {
    formState: { isValid, isSubmitting }
  } = useFormContext();

  return (
    <Toolbar
      sx={{
        justifyContent: "flex-end",
        backgroundColor: layoutMode === "dark" ? "transparent" : "white",
        gap: "5px"
      }}
    >
      <Button variant="text" type="button" onClick={goToPreviousPage} data-testid="cancelButton">
        Cancel
      </Button>
      <SaveButton
        variant="contained"
        icon={<span />}
        label={saveButtonLabel}
        mutationOptions={{ onSuccess }}
        disabled={!isValid || isSubmitting}
        onClick={refresh}
        data-testid="saveButton"
        alwaysEnable
      />
    </Toolbar>
  );
};
